import { Modal } from 'cpool-components/general/Modal';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuCircleX, LuLoaderCircle, LuSave, LuTrash2 } from 'react-icons/lu';

const SIDEBAR_WIDTH = '522px';

type Props = {
    children: React.ReactNode;
    description: string;
    isSaveDisabled?: boolean;
    isSubmitting?: boolean;
    onClose: () => void;
    onDelete?: () => void;
    onSubmit: React.FormEventHandler<HTMLFormElement>;
    open: boolean;
    title: string;
};

export const OfferModalShell: React.FC<Props> = ({
    children,
    description,
    isSaveDisabled = false,
    isSubmitting = false,
    onClose,
    onDelete,
    onSubmit,
    open,
    title,
}) => {
    const { t } = useTranslation();

    return (
        <Modal open={open} onClose={onClose} title={title} variant="sidebar" side="right" width={SIDEBAR_WIDTH}>
            <form className="flex flex-col flex-1 min-h-0 pt-4" onSubmit={onSubmit}>
                <div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto rounded-md bg-surface-light p-6">
                    <p className="text-14 text-midnight">{description}</p>
                    {children}
                </div>
                <div className="flex items-center justify-end gap-2 pt-4">
                    <Button
                        variant={ButtonVariant.SECONDARY}
                        iconLeft={<LuCircleX className="h-4 w-4" />}
                        onClick={onClose}
                        type="button"
                    >
                        {t('BUTTONS.CANCEL')}
                    </Button>
                    {onDelete && (
                        <Button
                            variant={ButtonVariant.SECONDARY}
                            iconLeft={<LuTrash2 className="h-4 w-4" />}
                            disabled={isSubmitting}
                            onClick={onDelete}
                            type="button"
                        >
                            {t('BUTTONS.DELETE')}
                        </Button>
                    )}
                    <Button
                        disabled={isSaveDisabled || isSubmitting}
                        iconLeft={
                            isSubmitting ? (
                                <LuLoaderCircle className="h-4 w-4 animate-spin" />
                            ) : (
                                <LuSave className="h-4 w-4" />
                            )
                        }
                        type="submit"
                    >
                        {t('BUTTONS.SAVE')}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};
